<template>
  <section>
    <NavbarView :fixed-top="true" :centered="true">
      <template #brand>
        <NavbarItemView tag="router-link" :to="{ path: '/' }">
          <template #body>
            <img width="150" class="is-hidden-tablet-only" src="@/assets/logos/logo.svg" />
            <img width="150" class="is-hidden-desktop" src="@/assets/logos/logo-responsive.svg" />
          </template>
        </NavbarItemView>
      </template>
      <template #end>
        <div class="p-3">
          <ButtonView class="is-primary is-light" @click="onLogin">
            {{ $t('auth.login') }}
          </ButtonView>
        </div>
      </template>
    </NavbarView>
    <router-view />
  </section>
</template>

<script>
import DocumentUIService from '/@/modules/core/app/services/DocumentUIService';
import { AuthRoute } from '/@/modules/auth/routes/auth.routes';
import ButtonView from '@/modules/core/ui/components/wrappers/ButtonView.vue';
import NavbarView from '@/modules/core/ui/components/wrappers/NavbarView.vue';
import NavbarItemView from '@/modules/core/ui/components/wrappers/NavbarItemView.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'SharedDocumentsLayout',
  components: { NavbarItemView, NavbarView, ButtonView },
  async beforeRouteEnter(to, from, next) {
    DocumentUIService.removeAppLoader();
    next();
  },
  methods: {
    onLogin() {
      this.$router.push({ name: AuthRoute.LOGIN.name });
    }
  }
};
</script>
